import { useEffect, useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { ListeRegles, verifierRegle } from './ReinitialiserMotDePasse';

const API = process.env.REACT_APP_BACKEND_URL;
const formaterDetail = (d) => {
  if (!d) return 'Une erreur est survenue.';
  if (typeof d === 'string') return d;
  if (d.regles_manquantes) return `${d.message} ${d.regles_manquantes.join(' · ')}`;
  return d.message || JSON.stringify(d);
};

// 🔐 Connexion P3 : page publique « Accepter l'invitation » — valider au chargement, règles en direct, connexion automatique au succès.
export default function AccepterInvitation() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [etat, setEtat] = useState({ valide: null });
  const [regles, setRegles] = useState(null);
  const [mdp, setMdp] = useState('');
  const [confirmer, setConfirmer] = useState('');
  const [erreur, setErreur] = useState('');
  const [chargement, setChargement] = useState(false);
  const [succes, setSucces] = useState(false);
  useEffect(() => {
    axios.get(`${API}/api/auth/invitation/valider`, { params: { token } }).then((r) => setEtat(r.data)).catch(() => setEtat({ valide: false, raison: 'invalide' }));
    axios.get(`${API}/api/auth/regles-mot-de-passe`).then((r) => setRegles(r.data)).catch(() => setRegles({ regles: { longueur_min: 8 }, liste: [] }));
  }, [token]);
  const conforme = regles && regles.liste.every((r) => verifierRegle(r.cle, mdp, regles.regles)) && mdp === confirmer && mdp.length > 0;
  const soumettre = async (e) => {
    e.preventDefault();
    setChargement(true); setErreur('');
    try {
      const { data } = await axios.post(`${API}/api/auth/invitation/accepter`, { token, mot_de_passe: mdp, confirmer });
      localStorage.setItem('auth_token', data.token);
      sessionStorage.removeItem('auth_token');
      setSucces(true);
      setTimeout(() => { window.location.assign('/'); }, 1200);
    } catch (err) { setErreur(formaterDetail(err?.response?.data?.detail)); } finally { setChargement(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b1437] p-4" data-testid="page-accepter-invitation">
      <div className="w-full max-w-md bg-white/5 border border-white/10 rounded-2xl p-8 text-slate-100 space-y-4">
        {etat.valide === null && <p className="text-sm text-slate-300" data-testid="invitation-verification">Vérification de l'invitation…</p>}
        {etat.valide === false && (
          <div className="space-y-4" data-testid="invitation-invalide">
            <h1 className="text-xl font-semibold">Invitation non valide</h1>
            <p className="text-sm text-red-300">Cette invitation n'est plus valide — demandez à votre gestionnaire de la renvoyer.</p>
            <Link to="/login" className="text-sm text-blue-300 hover:underline" data-testid="invitation-retour-connexion">Aller à la connexion</Link>
          </div>
        )}
        {etat.valide && succes && (
          <div className="space-y-2" data-testid="invitation-succes">
            <h1 className="text-xl font-semibold">Compte activé</h1>
            <p className="text-sm text-emerald-300">Votre mot de passe est enregistré. Connexion en cours…</p>
            <Button className="w-full" onClick={() => navigate('/')} data-testid="invitation-continuer">Continuer</Button>
          </div>
        )}
        {etat.valide && !succes && (
          <form onSubmit={soumettre} className="space-y-4" data-testid="invitation-formulaire">
            <h1 className="text-xl font-semibold" data-testid="invitation-bienvenue">Bienvenue {etat.prenom || ''}</h1>
            <p className="text-sm text-slate-300">Choisissez le mot de passe du compte <span className="font-mono" data-testid="invitation-email-masque">{etat.email_masque}</span>.</p>
            <Input type="password" value={mdp} onChange={(e) => setMdp(e.target.value)} placeholder="Mot de passe" className="bg-white/10 border-white/20 text-white" data-testid="invitation-mdp" />
            <Input type="password" value={confirmer} onChange={(e) => setConfirmer(e.target.value)} placeholder="Confirmer le mot de passe" className="bg-white/10 border-white/20 text-white" data-testid="invitation-confirmer" />
            {regles && <ListeRegles liste={regles.liste} regles={regles.regles} mdp={mdp} />}
            {confirmer && mdp !== confirmer && <p className="text-sm text-red-300" data-testid="invitation-non-identiques">Les mots de passe ne sont pas identiques.</p>}
            {erreur && <p className="text-sm text-red-300" data-testid="invitation-erreur">{erreur}</p>}
            <Button type="submit" className="w-full" disabled={!conforme || chargement} data-testid="invitation-soumettre">{chargement ? 'Activation…' : 'Activer mon compte'}</Button>
          </form>
        )}
      </div>
    </div>
  );
}
